import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ok",
  "use": "icon-ok-usage",
  "viewBox": "0 0 29 22",
  "content": "<symbol viewBox=\"0 0 29 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ok\">\n<path d=\"M10.6667 21.173L0.666748 11.173L3.48675 8.35301L10.6667 15.513L25.8467 0.333008L28.6667 3.17301L10.6667 21.173Z\" fill=\"#2F2F2F\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol